import {
   GynecologicalInterview,
   GynecologicalInterviewQuery,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { Message, MessageType } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

import { medicalDataTranslationKeys } from '../../../translations';
import { SidePanelLoader } from '../../SidePanelLoader';

type GynecologicalInterviewSidePanelListLoaderChildrenRenderProps = {
   gynecologicalInterviews: GynecologicalInterview[];
};

type GynecologicalInterviewSidePanelListLoaderProps = {
   readonly patientId: number;
   readonly children: (renderProps: GynecologicalInterviewSidePanelListLoaderChildrenRenderProps) => JSX.Element;
};

export const GynecologicalInterviewSidePanelListLoader = (
   props: GynecologicalInterviewSidePanelListLoaderProps
): JSX.Element => {
   const {
      data: gynecologicalInterviews,
      loading: gynecologicalInterviewsLoading,
      error: gynecologicalInterviewsError,
   } = useCqrsSearch<GynecologicalInterview>(() => {
      const query = new GynecologicalInterviewQuery();
      query.patientId = Slot.of(props.patientId);
      return query;
   });

   if (gynecologicalInterviewsLoading) {
      return <SidePanelLoader />;
   }

   if (gynecologicalInterviewsError) {
      return (
         <Message
            testId={'failedToFetchGynecologicalInterviews'}
            label={medicalDataTranslationKeys.failedToFetchMedicalInformation}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      gynecologicalInterviews: gynecologicalInterviews,
   });
};
